<template>
  <!-- Corpo -->
  <div class="bg-white rounded-lg shadow-md p-2 mb-4">
    <h1 class="text-center text-3xl font-bold mb-6">{{ welcomeTitle }}</h1>
    <div class="flex justify-center">
      <img :src="`/images/icons/reception-digitale/loghi-aziendali/`+$page.props.customer?.slug+`/loghi.png`" class="h-24">
    </div>
  </div>
  <div class="bg-white rounded-lg p-4 mb-4 pulse-red-border">
    <h1 class="text-center text-xl font-bold text-red-500">Selezionare il tipo di accesso:</h1>
  </div>
  <div class="p-2 flex flex-col lg:flex-row items-center gap-6 justify-center">
    <div class="w-full flex justify-center">
        <div class="flex gap-6 flex-wrap justify-center">
          <Link
              class="bg-white dark:bg-gray-900 shadow-md rounded-lg p-4 h-36 flex flex-col items-center justify-start text-center cursor-pointer hover:shadow-lg transition
                    w-full sm:w-56"
              :href="route('modules.rd-accesso-abituale')"
          >
              <img :src="`/images/icons/reception-digitale/accesso-abituale.png`" class="h-14 mb-2">
              <p class="text-base font-semibold text-gray-900 dark:text-gray-100 mb-1">Accesso abituale</p>
              <p class="text-xs text-gray-600 dark:text-gray-400">Frequent access</p>
          </Link>
          <Link
              class="bg-white dark:bg-gray-900 shadow-md rounded-lg p-4 h-36 flex flex-col items-center justify-start text-center cursor-pointer hover:shadow-lg transition
                    w-full sm:w-48"
              :href="route('modules.rd-accesso-occasionale')"
          >
              <img :src="`/images/icons/reception-digitale/accesso-occasionale.png`" class="h-14 mb-2">
              <p class="text-base font-semibold text-gray-900 dark:text-gray-100 mb-1">Accesso occasionale</p>
              <p class="text-xs text-gray-600 dark:text-gray-400">Temporary access</p>
          </Link>
          <div
              @click="showCorriereModal = true"
              class="bg-white dark:bg-gray-900 shadow-md rounded-lg p-4 h-36 flex flex-col items-center justify-start text-center cursor-pointer hover:shadow-lg transition
                    w-full sm:w-48"
              v-if="corriereEnabled"
          >
              <img :src="`/images/icons/reception-digitale/corriere.png`" class="h-14 mb-2">
              <p class="text-base font-semibold text-gray-900 dark:text-gray-100 mb-1">Corriere</p>
              <p class="text-xs text-gray-600 dark:text-gray-400">Courier</p>
          </div>
          <RichiestaAssistenza />
          <div class="w-full flex justify-center">
            <Link
                class="bg-white dark:bg-gray-900 shadow-md rounded-lg p-4 h-24 flex flex-row items-center justify-start text-left cursor-pointer hover:shadow-lg transition
                      w-full sm:w-72 max-w-md"
                :href="route('modules.rd-uscita')"
            >
                <img :src="`/images/icons/reception-digitale/exit.png`" class="h-14 mr-4">
                <div class="flex flex-col">
                  <p class="text-base font-semibold text-gray-900 dark:text-gray-100">Registrazione uscita</p>
                  <p class="text-xs text-gray-600 dark:text-gray-400">Checkout registration</p>
                </div>
            </Link>
          </div>
        </div>
    </div>
  </div>

  <!-- Modal Corriere -->
  <div v-if="showCorriereModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div class="bg-white dark:bg-gray-900 rounded-lg shadow-lg p-8 max-w-lg w-full mx-4">
      <h2 class="text-2xl font-bold text-center mb-6 text-gray-900 dark:text-gray-100">Scegli modalità corriere</h2>
      
      <div class="flex gap-6 justify-center">
        <Link
            :href="route('modules.rd-corriere-con-firma')"
            class="bg-white dark:bg-gray-800 shadow-md rounded-lg p-4 h-40 flex flex-col items-center justify-start text-center cursor-pointer hover:shadow-lg transition border border-gray-200 dark:border-gray-700
                  w-48"
        >
            <img :src="`/images/icons/reception-digitale/con-firma.png`" class="h-14 mb-2">
            <p class="text-base font-semibold text-gray-900 dark:text-gray-100 mb-1">Con firma</p>
            <p class="text-xs text-gray-600 dark:text-gray-400">With signature</p>
        </Link>
        
        <Link
            :href="route('modules.rd-corriere-senza-firma')"
            class="bg-white dark:bg-gray-800 shadow-md rounded-lg p-4 h-40 flex flex-col items-center justify-start text-center cursor-pointer hover:shadow-lg transition border border-gray-200 dark:border-gray-700
                  w-48"
        >
            <img :src="`/images/icons/reception-digitale/senza-firma.png`" class="h-14 mb-2">
            <p class="text-base font-semibold text-gray-900 dark:text-gray-100 mb-1">Senza firma</p>
            <p class="text-xs text-gray-600 dark:text-gray-400">Without signature</p>
        </Link>
      </div>
      
      <div class="mt-6 flex justify-center">
        <button 
            @click="showCorriereModal = false"
            class="px-6 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition"
        >
          Annulla
        </button>
      </div>
    </div>
  </div>

  <div class="bg-white rounded-lg shadow-md p-1 mb-3 ml-2" style="position:absolute; bottom:0">
    <div class="flex items-center justify-center space-x-2">
      <p class="text-center text-xs font-bold">Sviluppato da</p>
      <img :src="`/images/loghi-clienti/page93-srl.png`" class="h-10">
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/vue3';
import LayoutNoHeader from '@/Layouts/LayoutNoHeader.vue';
import RichiestaAssistenza from '@/Components/RichiestaAssistenza.vue';
import { ref } from 'vue';

export default {
  layout: LayoutNoHeader,
  props: ['corriereEnabled'],
  components: {
    Link,
    RichiestaAssistenza
  },
  computed: {
    welcomeTitle() {
      const titles = {
        'bona-spa': 'Benvenuti alla Reception Digitale del Gruppo Vincenzo Bona',
        'page93-srl': 'Benvenuti alla Reception Digitale di Page 93 S.r.l',
      };
      const slug = this.$page.props.customer?.slug;
      return titles[slug] || 'Benvenuti alla Reception Digitale';
    }
  },
  setup() {
    const showCorriereModal = ref(false);

    return {
      showCorriereModal
    };
  },
  mounted() {
    document.body.style.zoom = "130%";
    document.documentElement.style.overflow = "hidden";
  },
  unmounted() {
    document.body.style.removeProperty('zoom')
    document.documentElement.style.removeProperty('overflow')
  }
};
</script>